module.exports = __webpack_public_path__ + "fonts/akkurat_bold-webfont.f87e4f37.woff";